import { render, staticRenderFns } from "./error-overlay.vue?vue&type=template&id=00153d74&scoped=true"
import script from "./error-overlay.vue?vue&type=script&lang=js"
export * from "./error-overlay.vue?vue&type=script&lang=js"
import style0 from "./error-overlay.vue?vue&type=style&index=0&id=00153d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00153d74",
  null
  
)

export default component.exports